// Classes compartilhadas do fluxo de orçamento.
export const inputCls =
  'w-full rounded-md border border-border bg-bg-main px-3 py-2 text-sm text-text-title outline-none transition-colors placeholder:text-text-hint focus:border-primary';
export const labelCls = 'mb-1.5 block text-[13px] font-medium text-text-secondary';
export const panelCls = 'rounded-lg border border-border bg-card';
export const linkBtnCls =
  'text-sm font-medium text-primary underline-offset-4 hover:underline focus:outline-none focus-visible:underline';

export const nf = (v: string) => (v === '' ? 0 : Number(v));

export const pct = (v: number) => `${v.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`;
